import { LockClosedIcon } from '@heroicons/react/solid'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changePassword } from '../redux/UserActions'

export default function ResetPassword() {
    const query = new URLSearchParams(window.location.search);
    document.title = "Wellm8 Password Reset Form"
    const userSelector = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [data, setData] = useState({
        "email": query.get('mail'),
        "token": query.get('token'),
        "password": "",
        "cpassword": ""
    })

    useEffect(() => {
        if (userSelector.passwordStatus === "fulfilled") {
            setData({
                "email": query.get('mail'),
                "token": query.get('token'),
                "password": "",
                "cpassword": ""
            })
        }
    }, [userSelector.passwordStatus])

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <img
                        className="mx-auto h-24 w-auto"
                        src={process.env.PUBLIC_URL + '/LogoPassword.svg'}
                        alt="Workflow"
                    />
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset your password</h2>
                </div>
                <form className="mt-8 space-y-6" action="#"
                    onChange={(e) => {
                        setData({
                            ...data,
                            [e.target.name]: e.target.value
                        })
                    }}
                    onSubmit={(e) => {
                        e.preventDefault()
                        if (data.password !== data.cpassword) {
                            alert("Passwords doesn't match!")
                            return
                        }
                        dispatch(changePassword({ "Mail": data.email, "Token": data.token, "Password": data.password }))
                    }}>
                    <input type="hidden" name="remember" defaultValue="true" />
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div className="hidden">
                            <label htmlFor="email-address" className="sr-only">
                                Email address
                            </label>
                            <input
                                id="email-address"
                                name="email"
                                type="email"
                                autoComplete="email"
                                value={data.email}
                                required
                                className="bg-gray-200 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Email address"
                                readOnly={true}
                            />
                            <label htmlFor="email-address" className="sr-only">
                                Token
                            </label>
                            <input
                                id="token"
                                name="token"
                                type="text"
                                value={data.token}
                                autoComplete="token"
                                required
                                className="bg-gray-200 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Token"
                                readOnly={true}

                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">
                                New Password
                            </label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                value={data.password}
                                autoComplete="current-password"
                                required
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="New Password"
                            />
                            <label htmlFor="password" className="sr-only">
                                Confirm Password
                            </label>
                            <input
                                id="cpassword"
                                name="cpassword"
                                type="password"
                                value={data.cpassword}
                                autoComplete="confirm-password"
                                required
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Confirm Password"
                            />
                        </div>
                    </div>


                    <div>
                        <button
                            type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                                <LockClosedIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" />
                            </span>
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}